import { render, staticRenderFns } from "./bloodOxygen.vue?vue&type=template&id=427d927b&scoped=true&"
import script from "./bloodOxygen.vue?vue&type=script&lang=js&"
export * from "./bloodOxygen.vue?vue&type=script&lang=js&"
import style0 from "./bloodOxygen.vue?vue&type=style&index=0&id=427d927b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d927b",
  null
  
)

export default component.exports